const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator

function vibrate(pattern) {
  if (canVibrate) {
    navigator.vibrate(pattern)
  }
}

// false = failed permanently, null = not yet initialized
let audioCtx = null

function getAudioContext() {
  if (audioCtx === false) return null
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)()
    } catch (_) {
      audioCtx = false
      return null
    }
  }
  return audioCtx
}

function playTone(frequency, duration, startTime = 0) {
  const ctx = getAudioContext()
  if (!ctx) return

  const oscillator = ctx.createOscillator()
  const gainNode = ctx.createGain()

  oscillator.connect(gainNode)
  gainNode.connect(ctx.destination)

  oscillator.type = 'sine'
  oscillator.frequency.value = frequency

  // Fade out to avoid click
  const start = ctx.currentTime + startTime
  gainNode.gain.setValueAtTime(0.3, start)
  gainNode.gain.exponentialRampToValueAtTime(0.01, start + duration / 1000)

  oscillator.onended = () => {
    oscillator.disconnect()
    gainNode.disconnect()
  }

  oscillator.start(start)
  oscillator.stop(start + duration / 1000)
}

function successBeep() {
  playTone(880, 150)
}

function errorBeep() {
  playTone(440, 100)
  playTone(440, 100, 0.15)
}

export function useHaptics() {
  return {
    successVibrate: () => vibrate(50),
    errorVibrate: () => vibrate([50, 100, 50]),
    warningVibrate: () => vibrate(100),
    vibrate,
    successBeep,
    errorBeep,
    successFeedback: () => { vibrate(50); successBeep() },
    errorFeedback: () => { vibrate([50, 100, 50]); errorBeep() },
  }
}
